<template>
  <div class="modal-klarna-overlay" @click="closeKlarnaModal">
    <div class="modal-klarna-container">
      <div class="col-12">
        <div class="row">
          <span class="col-12 modal-k-header">Klarna.</span>
          <span class="col-12 modal-text">{{ t('modal.klarna.text.1') }}</span>
          <div class="col-12 modal-semi-content">
            <div class="modal-row">
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.2') }}
                </span>
              <div class="arrow-container">
                <span class="arrow"></span>
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.3') }}
                </span>
              </div>
              <div class="arrow-container">
                <span class="arrow second-el"></span>
                <span class="col-12 text-left content-margin d-block">
                  {{ t('modal.klarna.text.4') }}
                  <img src="/ui/main/img/klarna-icon.svg" alt="Klarna icon">
                </span>
              </div>
              <div class="arrow-container">
                <span class="arrow third-el"></span>
                <span class="col-12 d-flex text-left content-margin">
                  {{ t('modal.klarna.text.5') }}
                </span>
              </div>
              <span class="col-12 text-left content-margin terms-klarna pr-0" v-html="t('modal.klarna.text.6')"></span>
            </div>
          </div>
          <span class="close-btn" @click="closeModal">{{ t('close.modal.text') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeKlarnaModal(event) {
      if (event.target.classList.contains('modal-klarna-overlay')) {
        this.$emit('close');
      }
    },
    closeModal(event) {
      if (event.target.classList.contains('close-btn')) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-klarna-overlay {
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.modal-klarna-container {
  width: 550px;
  height: auto;
  background-color: #ffffff;
  padding: 20px 0;
  border-radius: 10px;
  position: relative;
  top: 5%;
}

.close-btn {
  display: inline-block;
  padding: 8px 16px;
  background-color: #000000;
  color: #ffffff;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  border: 2px solid #000000;
  width: 75%;
  margin: 0 auto 1.5rem auto;
  @media screen and (max-width:575px) {
    width: 80%;
  }
  &:hover {
    color: #000000;
    background-color: #ffffff;
    border: 2px solid #000000;
  }
}

.modal-k-header {
  text-align: center;
  font-size: 1.75rem;
  color: #989593;
  font-weight: 800;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.modal-text {
  color: #000000;
  font-size: 1.75rem;
  font-weight: 700;
  text-align: center;
  @media screen and (max-width: 575px) {
    font-size: 1.5rem;
  }
  @media screen and (max-width: 380px) {
    font-size: 1.375rem;
  }
}

.modal-semi-content {
  color: #000000;
  font-size: 0.813rem;
  font-weight: 700;
  text-align: center;
  display: flex;
  padding: 0;
}

.modal-row {
  display: flex;
  flex-wrap: wrap;
  width: 70%;
  margin: 0 auto;
  justify-content: flex-start;
  @media screen and (max-width: 380px) {
    width: 80%;
  }
}

.content-margin {
  margin: 15px 0;
  line-height: 1.2rem;
  padding: 0;
}

.terms-klarna {
  color: #8C8C8C;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-bottom: 1.8rem;
  margin-top: 1rem;
  padding: 0;
  font-weight: 500;
}

.arrow-container {
  position: relative;
  @media screen and (max-width: 575px) {
    .second-el {
      top: 35%;
    }
  }
  img {
    width: 40px;
  }
}

.arrow {
  position: absolute;
  top: 50%;
  left: -15px;
  margin-top: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #989593;
}

.arrow-last {
  position: absolute;
  top: 28%;
  left: -15px;
  margin-top: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #989593;
}
</style>
